export const formatCardCvc = (cardCvc) => {
    const formattedCardCvc = cardCvc.replace(/\D/g, '').substring(0, 4);
    return formattedCardCvc;
};
//# sourceMappingURL=format-card-cvc.js.map